"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.capitalizeFirst = exports.capitalize = void 0;
const capitalize = string => string && typeof string === 'string' ? string.toUpperCase() : string;
exports.capitalize = capitalize;
const capitalizeFirst = string => string && typeof string === 'string' ? capitalize(string.charAt(0)) + string.slice(1) : string;
exports.capitalizeFirst = capitalizeFirst;